import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

const TAILWIND_CONFIG = {
    breakpoints: {
        print: 'print',
        sm: '(min-width: 375px)',
        md: '(min-width: 768px)',
        lg: '(min-width: 1024px)',
        xl: '(min-width: 1440px)',
    } as Record<string, string>,
    themes: {} as Record<string, unknown>,
};

@Injectable()
export class FuseTailwindService {
    get tailwindConfig$(): Observable<typeof TAILWIND_CONFIG> {
        return of(TAILWIND_CONFIG);
    }
}
